import React, { useEffect, useRef } from "react";
import { useInView } from "framer-motion";
import { annotate } from "rough-notation";

export function Highlighter({
    children,
    action = "highlight",
    color = "#ffd1dc",
    strokeWidth = 1.5,
    animationDuration = 600,
    iterations = 2,
    padding = 2,
    multiline = true,
    isView = false,
}) {
    const elementRef = useRef(null);
    const annotationRef = useRef(null);

    const isInView = useInView(elementRef, {
        once: true,
        margin: "-10%",
    });

    // If isView is false, always show. If isView is true, wait for inView
    const shouldShow = !isView || isInView;

    useEffect(() => {
        if (!shouldShow) return;

        const element = elementRef.current;
        if (!element) return;

        const annotationConfig = {
            type: action,
            color,
            strokeWidth,
            animationDuration,
            iterations,
            padding,
            multiline,
        };

        const annotation = annotate(element, annotationConfig);

        annotationRef.current = annotation;
        annotationRef.current.show();

        const resizeObserver = new ResizeObserver(() => {
            annotation.hide();
            annotation.show();
        });

        resizeObserver.observe(element);
        resizeObserver.observe(document.body);

        return () => {
            if (element) {
                annotate(element, { type: action }).remove();
                resizeObserver.disconnect();
            }
        };
    }, [
        shouldShow,
        action,
        color,
        strokeWidth,
        animationDuration,
        iterations,
        padding,
        multiline,
    ]);

    return (
        <span ref={elementRef} className="relative inline-block bg-transparent">
            {children}
        </span>
    );
}
